import React from "react";

import { BusinessAccountAction, BusinessAccountResponse } from "../../../../datatypes/businessaccounts/BusinessAccount";
import { FormattedMessage } from "react-intl";
import _ from "lodash";
import LinkContainer from "../../LinkContainer";
import { History } from "history";

type Props = {
    data: BusinessAccountResponse | undefined | null;
    history?: History;
};

/**
 * Note that this must also work, if we don't have any BussinessAccountData!
 */
function getProfileAndSettings(props: Props): BusinessAccountAction | undefined | null {
    if (!props.data) {
        return null;
    }
    return _.get(props.data.getActiveAccount(), ["actions", "profileAndSettings"]);
}

export function ProfileLink(props: Props) {
    const action = getProfileAndSettings(props);
    const link = props.history ? "" : "/portal";
    if (action) {
        return (
            <a href={action.url} className="test-account-menu-account-link">
                {action.text}
            </a>
        );
    }
    const handlePortalClick = (event: React.MouseEvent<HTMLDivElement>) => {
        if (props.history) {
            event.preventDefault();
            props.history.push("/portal");
        }
        return null;
    };
    return (
        <li role="presentation">
            <LinkContainer
                to={link}
                onClick={(event) => handlePortalClick(event)}
                customClass="test-account-menu-account-link">
                <FormattedMessage id="EX_MY_ACCOUNT_LINK_IN_HEADER" />
            </LinkContainer>
        </li>
    );
}
